module.exports = __webpack_public_path__ + "img/img25.e151ff3c.png";